import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MapFilters, MapFilterService } from '../../../services/filter.service';
import { LayoutService } from '../../../services/layout.service';
import { Component, inject } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
// Optional (falls du Slide-Toggles verwenden willst, im Template einfach nutzen):
// import { MatSlideToggle } from '@angular/material/slide-toggle';

type FilterKey =
  | 'playground'
  | 'restaurant'
  | 'gasStation'
  | 'kiosk'
  | 'shower'
  | 'wifi'
  | 'picnicArea'
  | 'chargingStation'
  | 'atm'
  | 'isFee';

interface FilterToggle {
  key: FilterKey;
  label: string;
  icon: string; // Material Icon Name
}

@Component({
  selector: 'app-map-filter',
  standalone: true,
  imports: [AsyncPipe, MatButtonModule, MatIconModule, NgForOf, NgIf, MatDivider /*, MatSlideToggle*/],
  templateUrl: './map-filter.component.html',
  styleUrls: ['./map-filter.component.scss'],
})
export class MapFilterComponent {
  public filterService = inject(MapFilterService);
  public layoutService = inject(LayoutService);
  hoverRating = 0;

  // Definition der Toggle-Buttons (Icon-Namen sind Material Icons)
  public readonly toggles: FilterToggle[] = [
    { key: 'playground', label: 'Spielplatz', icon: 'attractions' },
    { key: 'restaurant', label: 'Restaurant', icon: 'restaurant' },
    { key: 'gasStation', label: 'Tankstelle', icon: 'local_gas_station' },
    { key: 'kiosk', label: 'Kiosk', icon: 'storefront' },
    { key: 'shower', label: 'Dusche', icon: 'shower' },
    { key: 'wifi', label: 'WLAN', icon: 'wifi' },
    { key: 'picnicArea', label: 'Picknick', icon: 'park' },
    { key: 'chargingStation', label: 'Laden', icon: 'ev_station' },
    { key: 'atm', label: 'Geldautomat', icon: 'atm' },
    { key: 'isFee', label: 'Gebühr', icon: 'euro' },
  ];

  // TrackBy für performantes Rendering
  trackByKey(_: number, t: FilterToggle): string {
    return t.key;
  }

  // UI-Helfer: Ist ein Filter aktiv?
  isActive(key: FilterKey): boolean {
    const f = this.filterService.getCurrentFilters();
    return Boolean(f[key]);
  }

  // Toggle eines booleschen Filters
  toggleFilter(filter: keyof MapFilters): void {
    const currentFilters = this.filterService.getCurrentFilters();
    const newFilters = {
      ...currentFilters,
      [filter]: currentFilters[filter] !== true,
    };
    this.filterService.updateFilters(newFilters);
  }

  // Rating-Logik
  setRating(rating: number): void {
    const currentRating = this.filterService.getCurrentFilters().minRating;
    const newRating = currentRating === rating ? 0 : rating;
    this.filterService.updateFilters({ minRating: newRating });
  }

  getRatingLabel(filters: MapFilters | null): string {
    if (!filters || filters.minRating === 0) {
      return 'Alle Bewertungen';
    }
    return `Mindestens ${filters.minRating} Sterne`;
  }

  // Preis-Handling (z. B. an ein Slider/Number-Input bindbar)
  setPrice(price: number | null): void {
    // null bedeutet: kein Preisfilter
    this.filterService.updateFilters({ price: price ?? null });
  }

  resetFilters(): void {
    this.filterService.resetFilters();
  }
}
